import type { UpdateOneShopPreferencesDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";
import { useApiMutation } from "./use-api-mutation";
import { shopQueryKey } from "./use-shop-suspense";

export default function useUpdateShopPreferences(shopId: string) {
  const invalidateShop = useInvalidateShop(shopId);

  return useApiMutation("patch", "/shops/{shopId}/preferences", {
    invalidate: invalidateShop,
    mapVariables: (body: UpdateOneShopPreferencesDto) => ({
      params: { path: { shopId } },
      body: {
        ...body,
      },
    }),
  });
}

export function useUpdateShopWalletPreferences(shopId: string) {
  return useApiMutation("patch", "/shops/{shopId}/preferences/wallet", {
    meta: {
      success: {
        title: "misc.form.success.title",
        message: "misc.form.success.message",
      },
      error: {
        title: "misc.form.error.title",
        message: "misc.form.error.message",
      },
      invalidatesQuery: shopQueryKey(shopId),
    },
    mapVariables: (data: {
      title?: string;
      backgroundColor?: string;
      logoFile?: File;
      bannerFile?: File;
    }) => {
      const formData = new FormData();

      if (data.logoFile) {
        formData.append("logo", data.logoFile);
      }
      if (data.bannerFile) {
        formData.append("banner", data.bannerFile);
      }

      if (data.title) {
        formData.append("title", data.title);
      }
      if (data.backgroundColor) {
        formData.append("backgroundColor", data.backgroundColor);
      }

      return {
        params: { path: { shopId } },
        body: formData as unknown,
      };
    },
  });
}
